<template>
    <div class="content">
        <div class="title">
            <i class="GKIcon"></i>
            <div class="titleData">
                <div class="titleName">中央稿库</div>
                <div class="name-number" v-for="item in GKdataList">
                    <span class="name">{{item.name}}</span>
                    <span class="number">{{item.number}}</span>
                </div>
            </div>
        </div>
        <div class="dataList">
            <ul>
                <li class="thead">
                    <span class="item-1"></span>
                    <span class="item-2">待编</span>
                    <span class="item-3">待审</span>
                </li>
                <li class="tbody" v-for="item in dataList">
                    <i :class="['item-1',item.class]">{{item.name}}</i>
                    <span class="item-2">{{item.edit}}</span>
                    <span class="item-3">{{item.auditing}}</span>
                </li>
            </ul>
        </div>
        <div class="circular">
            <p id="num_bian_text">0</p>
            <main>
                <h3>编</h3>
                <div class="beam"></div>
                <div class="bg rotateX">
                    <div class="rotateZ"></div>
                </div>
            </main>
        </div>
        <div class="path" id="path" v-if="pulse.show"><img :src="img(require('@/assets/images/GIF/bianPath.gif'))"></div>
    </div>
</template>

<script>
    import {numAnimation} from '../../assets/js/common'
    export default {
        name: "bianModule",
        data() {
            return {
                amountBian: 0,
                GKdataList: [{
                    name: '共享稿',
                    number: 0
                },{
                    name: '取用稿',
                    number: 0
                }],
                dataList: [
                    {
                        name:'纸媒',
                        class:'paper',
                        edit:0,
                        auditing:0,
                    },
                    {
                        name:'网站',
                        class:'website',
                        edit:0,
                        auditing:0,
                    },
                    {
                        name:'客户端',
                        class:'client',
                        edit:0,
                        auditing:0,
                    },
                ],
                pulse: {
                    show: false,
                    dur: 1600
                },
                timer: null
            }
        },
        mounted(){
            this.getData();
            this.timer =setInterval(() => {
                this.getData();
            }, 1000*60*15);
        },
        watch: {
            amountBian: function (n, o) {
                if (n !== o && n !== 0) {
                    this.pulse.show = true;
                    setTimeout(() => {
                        numAnimation("num_bian_text", {
                            time: 1500,
                            num: n,
                            regulator: 100,
                            start: o ? o : 0,
                        });
                        this.pulse.show = false;
                    }, this.pulse.dur);
                }
            }
        },
        computed: {
            img(){
                return function (path) {
                    return path + '?' + new Date().getTime();
                }
            },
        },
        methods: {
            getData(){
                this.axios.get('/bigscreen/bianfacenter.json').then(res => {
                    var list = res.data.data;

                    this.amountBian = list.bianCount;

                    this.dataList[0].edit = list.paperBianCount;
                    this.dataList[0].auditing = list.paperShenCount;

                    this.dataList[1].edit = list.webBianCount;
                    this.dataList[1].auditing = list.webShenCount;

                    this.dataList[2].edit = list.appBianCount;
                    this.dataList[2].auditing = list.appShenCount;
                    
                });

                this.axios.get('/bigscreen/CenterLibrary.json').then(res => {
                    var countObj = res.data.data;
                    this.GKdataList[0].number = countObj['共享稿'];
                    this.GKdataList[1].number = countObj['取用稿'];
                })
            }
        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    }
</script>

<style scoped>
    .content{
        font-size: 25px;
        position: relative;
    }
    .content .path{
        position: absolute;
        top: -62px;
        left: 28px;
    }
    .content .GKIcon{
        width: 69px;
        height: 69px;
        background: url("../../assets/images/GKIcon.png")center center no-repeat;
        background-size: 100% 100%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 7px;
        float:left;
    }
    .content .titleData{
        border: #2589f5 1px solid;
        border-radius: 2px;
        line-height: 67px;
        display: inline-block;
        padding: 0 12px 0 33px;
    }
    .titleData .number{
        color: #00ffff;
    }
    .titleData .titleName{
        margin-right: 38px;
        float:left;
    }
    .titleData .name-number {
        float:left;
        width: 164px;
    }
    .titleData .name{
        margin-right: 20px;
    }
    .titleData .number{
        margin-right: 10px
    }
    .circular{
        width: 264px;
        height: 264px;
        position: absolute;
        left: 290px;
        bottom: 298px;
    }
    .circular main{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .circular .bg{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .circular .bg.rotateX{
        transform: rotateX(60deg);
    }
    .circular .rotateZ{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url("../../assets/images/circle.png") center center no-repeat;
        background-size: 100% 100%;
        transform: rotateZ(60deg);
        animation: circular-bg 5s linear 0s infinite normal;
    }
    .circular h3{
        font-size: 48px;
    }
    .circular p{
        font-size: 50px;
        color: #eacb42;
        font-weight: bold;
        position: absolute;
        left: 30px;
        width: 200px;
        text-align: center;
    }
    .beam{
        width: 240px;
        height: 129px;
        position: absolute;
        background: url("../../assets/images/beam.png")center center no-repeat;
        background-size: 100% 100%;
        bottom: 110px;
        left: 10px;
    }
    @keyframes circular-bg {
        0% {transform: rotateZ(60deg);}
        100% {transform: rotateZ(420deg)}
    }
    .dataList{
        width: 578px;

    }
    .dataList .item-1{
        display: block;
        float: left;
        width: 255px;
        height: 45px;
        box-sizing: border-box;
    }
    .dataList .tbody .item-1{
        border-radius: 50px;
        border: 2px solid #2179d9;
        /*border-image: linear-gradient(to right,#091937,#2589f5);*/
        background-image: linear-gradient(to right,#091937,#123c70);
        position: relative;
        text-indent: 90px;
        line-height: 45px;
        margin-top: 8px;
    }
    .dataList .tbody .item-1:before{
        content: '';
        display: block;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background: #2589f5;
        position: absolute;
        top: 0;
        left: 0;
    }
    .dataList .tbody .item-1.paper:before{
        background:#2589f5 url("../../assets/images/icon-paper.png") center center no-repeat;
    }
    .dataList .tbody .item-1.website:before{
        background:#2589f5 url("../../assets/images/icon-website.png") center center no-repeat;
    }
    .dataList .tbody .item-1.client:before{
        background:#2589f5 url("../../assets/images/icon-client.png") center center no-repeat;
    }
    .dataList .item-2,.dataList .item-3{
        display: block;
        float: left;
        width: 105px;
        height: 100%;
        margin-left: 55px;
        text-align: center;
        background: rgba(17,54,103,0.5);
        color: #4afffd;
        line-height: 60px;
    }
    .dataList .thead .item-2,.dataList .thead .item-3{
        background: none;
        color: #88b5fb;
    }
    .dataList .tbody{
        border-top: 2px solid #1a5da8;
    }
    .dataList li:nth-child(2){
        border: none;
    }
    .dataList .thead{
        height: 50px;
    }
    .dataList .tbody{
        height: 60px;
        background-image: linear-gradient(to right,#091834,#0c213f);
    }
</style>
